import type { ReactNode } from "react";
import { useLabels, useMapCore } from "../hooks";
import { FullscreenButton } from "./FullscreenButton";
import { LocateButton } from "./LocateButton";
import { MeasureButton } from "./MeasureButton";

export type ToolStackProps = {
  children?: ReactNode;
  className?: string;
};

export function ToolStack({ children, className }: ToolStackProps) {
  const core = useMapCore();
  const labels = useLabels();
  const controls = core.options.controls;
  const content =
    children ?? (
      <>
        {controls.locate ? <LocateButton /> : null}
        {controls.fullscreen ? <FullscreenButton /> : null}
        {controls.measure ? <MeasureButton /> : null}
      </>
    );

  return (
    <div className={["fxmap-tools", "fxmap-stack", className ?? ""].filter(Boolean).join(" ")} role="toolbar" aria-label={labels.measure} aria-orientation="vertical" data-fxmap="tools">
      {content}
    </div>
  );
}
